import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

export const registrationLinkGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (route.queryParamMap.get('link')) return true;
  return inject(Router).createUrlTree(['/']);
};
